function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This function is used to generate typography definitions for the theme.
 * @param {Semantics} semantics from foundation.
 */

var makeKeyMapping = typographyObj => {
  return {
    fontFamily: typographyObj.family,
    fontSize: typographyObj.size,
    fontWeight: typographyObj.weight,
    lineHeight: typographyObj.lineHeight
  };
};
var typography = semantics => {
  var applyTypography = typographyKey => {
    var small = makeKeyMapping(semantics.typography.small[typographyKey]);
    var medium = makeKeyMapping(semantics.typography.medium[typographyKey]);
    var large = makeKeyMapping(semantics.typography.large[typographyKey]);
    return _objectSpread(_objectSpread({
      WebkitFontSmoothing: 'auto'
    }, small), {}, {
      ["@media (min-width: ".concat(semantics.breakpoint.sm.min, "px)")]: medium,
      ["@media (min-width: ".concat(semantics.breakpoint.lg.min, "px)")]: large
    });
  };
  var typographyKeys = Object.keys(semantics.typography.small);
  return typographyKeys.reduce((acc, key) => {
    acc[key] = applyTypography(key);
    if (key.startsWith('overline')) {
      acc[key].textTransform = 'uppercase';
    }
    return acc;
  }, {});
};
export { typography };